export enum Colors {
  DefaultPrimaryColor = '#ef4b4f',
  DefaultTintColor = '#fff',
  Success = '#25d366',
}
